import { x } from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';

import EnvelopeIcon from '~/assets/icons/envelope.svg';
import { Card } from '~/ui/card/Card';
import { Flex } from '~/ui/flex/Flex';
import { Item, registry, RenderProps } from '../Item';
import { ENVELOPE } from '../itemIds';
import EnvelopeImage from './envelope.png';
import { Logo } from '~/ui/logo/Logo';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import * as S from './styles';

interface Props {
  from: string;
  subject: string;
  logo?: string;
}

const selector = (s: TrainingState) => select(s, 'logoUrl', 'featureShowLlama');

export class Envelope extends Item<typeof ENVELOPE, Props> {
  protected render({ children, logo }: RenderProps<Props>) {
    const { logoUrl, featureShowLlama } = useTrainingStore(selector);

    return (
      <Flex variant="center">
        <Card
          backgroundColor="white"
          className="envelopeStyleForDarkTheme"
          color="greyDark"
          display="flex"
          flexDirection="column"
          marginBottom={{ _: '0px', lg: '100px' }}
          minH="300px"
          paddingBottom="20px"
          position="relative"
          w={{ _: '350px', md: '399px' }}
        >
          <S.Header>
            <EnvelopeIcon />

            <x.b>{t`You've got mail!`}</x.b>
          </S.Header>

          <x.div zIndex={3} p="20px" paddingBottom="70px">
            <S.Body>{children}</S.Body>
          </x.div>

          {logo ? (
            <Logo
              src={
                typeof logo === 'string' && logo.trim() !== '' ? logo : logoUrl
              }
              height={96}
              style={{
                position: 'absolute',
                zIndex: 1,
                bottom: '20px',
                right: '60px',
                width: '96px',
                height: '96px',
                objectFit: 'contain'
              }}
            />
          ) : featureShowLlama ? (
            <S.Stamp />
          ) : null}

          <S.EnvelopeBackground src={EnvelopeImage} alt="" />
        </Card>
      </Flex>
    );
  }
}

registry[ENVELOPE] = Envelope;
